import Icon, { DownOutlined } from '@ant-design/icons'
import { Dropdown } from 'antd'
import styled from 'styled-components'

export const StyledDropdown = styled(Dropdown)`
  cursor: pointer;
  z-index: 0;
`

export const ButtonIcon = styled(Icon)`
  width: 30px;
  color: #000;
  padding: 0px 5px;
  font-size: 20px;
`

export const DownLogo = styled(DownOutlined)`
  color: #000fe;
  font-size: 10px;
`
